<script lang="ts" setup>
// #上三張圖片，下一張圖片
import { type Image } from '@/utils/types/Image'
const props = defineProps({
  data: {
    type: Object
  }
})

const imgData1 = ref()
const imgData2 = ref()

if (props.data) {
  const img1: Ref<Image> = ref(props.data.image_tops)
  const img2: Ref<Image> = ref(props.data.image_bottom)
  imgData1.value = img1.value
  imgData2.value = img2.value
}
</script>

<template>
  <div class="area">
    <div class="area__top">
      <figure class="area__pic" v-for="(item, index) in imgData1" :key="index">
        <Nimg :src="item.link" :title="item.title" :alt="item.alt" format="webp" />
      </figure>
    </div>
    <figure class="area__bottom">
      <Nimg :src="imgData2?.link" :title="imgData2?.title" :alt="imgData2?.alt" format="webp" />
    </figure>
  </div>
</template>

<style lang="scss" scoped>
.area {
  padding-top: toRem(20);
  padding-bottom: toRem(20);

  @include max-media(480) {
    flex-wrap: wrap;
  }

  img {
    display: block;
    width: 100%;
  }

  &__top {
    display: flex;
    justify-content: space-between;

  }

  &__bottom {
    width: 100%;
    margin-bottom: toRem(22);
  }

  &__pic {
    width: calc((100% - toRem(46)) / 3);

    @include max-media(480) {
      width: 33.3333%;
    }
  }
}
</style>
